import { MemberDatasource, IMemberDatasource } from './../../../global/datasources/member_datasource';
import { IDelegateResponder, IDelegateConstant, IDelegateController } from 'ui-ng-delegate';
import { ICommand } from 'core-ts-types';
import { Major } from '../../builders/major_builder';

export class TransferMajorTileController {
  public major: Major;
  public memberDatasource: IMemberDatasource;

  constructor(
    private $scope: ng.IScope,
    private loadTransferMajorDegreeAuditCommand: ICommand,
    private deselectTransferMajorCommand: ICommand,
    private ngMemberDatasource: MemberDatasource,
    private $element: JQuery,
    private $state: ng.ui.IStateService,
    private ngMajorBuilder: typeof Major
  ) {
    const defaultMajor: Major = this.ngMajorBuilder.build({});

    this.$scope.major = this.major = this.$scope.major || defaultMajor;

    this.memberDatasource = this.ngMemberDatasource.read();

    if (!_.isUndefined(this.major.id) && this.isAuditAvailable()) {
      this.loadTransferMajorDegreeAuditCommand(this.major.id);
    }
  }

  hasMajor(): boolean {
    return !!this.$scope.major && !!this.$scope.major.displayTitle;
  }

  get majorTitle(): string {
    const words = this.major.displayTitle.split(' ');
    if (this.major.displayTitle.length > 40 && words.length > 5) {
      return `${_.take(words, 3).join(' ')}...${_.takeRight(words, 2).join(' ')}`;
    }
    return this.major.displayTitle;
  }

  isAuditAvailable(): boolean {
    return (this.hasMajor() && this.$scope.major.auditAvailable) || !this.hasMajor();
  }

  isPreProf(): boolean {
    return this.hasMajor() && this.$scope.major.preprof_ind;
  }

  isRegularMajor(): boolean {
    return this.isAuditAvailable() && !this.isPreProf();
  }

  isCreditBasedCompletion(): boolean {
    return this.$scope.major.degree_completion_type == 'credit';
  }

  onMouseEnterCloseButton(): void {
    this.$element.children('.tile').removeClass('active');
  }

  onMouseLeaveCloseButton(): void {
    this.$element.children('.tile').addClass('active');
  }

  showMajorDetails($event: Event): void {
    const selectors = ['.major-view-detail-remove-button', '.major-view-detail-button'];
    for (let selector of selectors) {
      const button = this.$element.find(selector)[0] as HTMLElement;
      if (!button || $event.target === button || button.contains($event.target as HTMLElement)) {
        return;
      }
    }

    if (this.isRegularMajor()) {
      this.$state.go('my.transfer.major_details', {
        majorId: this.$scope.major.id
      });
    }
  }

  deleteMajor($event: Event): void {
    this.deselectTransferMajorCommand(this.major);
  }
}

class TransferMajorTileDelegate {
  constructor(DelegateController: IDelegateController, transferMajorTileDelegateConfiguration: IDelegateConstant) {
    DelegateController(this, transferMajorTileDelegateConfiguration);
  }
}

angular
  .module('capability-ng-transfer')
  .service('transferMajorTileDelegate', TransferMajorTileDelegate)
  .controller('ngTransferMajorTileController', TransferMajorTileController)
  .factory('transferMajorTileDelegateConfiguration', (loadTransferMajorDegreeAuditCommand: ICommand) => {
    return {
      uniqueComponent: 'transfer-major-tile',
      vocabulary: {
        updateDegreeAudit: function(scope: any) {
          if (!scope.major.preprof_ind) {
            loadTransferMajorDegreeAuditCommand(scope.major.id);
          }
        }
      }
    };
  })
  .directive('transferMajorTile', function(
    DelegateResponder: IDelegateResponder,
    transferMajorTileDelegateConfiguration: IDelegateConstant
  ) {
    return {
      controller: 'ngTransferMajorTileController',
      templateUrl: 'lib/transfer/components/major_tile/major_tile.html',
      controllerAs: '$ctrl',
      scope: {
        major: '<'
      },
      link: DelegateResponder(transferMajorTileDelegateConfiguration, function(scope, element, attrs) {})
    };
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/components/major_tile/major_tile.ts